// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1kqYP","toggle":"styles_toggle__2mApN","preview":"styles_preview__3TEzZ"};